import { Sprite } from "pixi.js";
import GameModel from "../../../../vendor_core/core/src/model/GameModel";
import { DefaultLayers } from "../../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../../vendor_core/core/src/utils/ViewManager";
import Layout from "../../../../vendor_core/core/src/utils/Layout";
import { Timeline } from "../../../../vendor_core/core/src/Timeline";
import { Ease } from "../../../../vendor_core/core/src/Ease";

class LogoHelper {

    private logo: Sprite;
    private secondLogo: Sprite;
    private chinesLogo: Sprite;
    private timeline: Timeline;


    public init() {
        let isChines: boolean = (GameModel.lang == "zh-cn" || GameModel.lang == "zh-tw");
        // set preloader logo
        const preloadScene = ViewManager.getLayer(DefaultLayers.Preloader).setScene("start");
        preloadScene.sceneSprites.get("logo2")
            .visible = !isChines;
        preloadScene.sceneSprites.get("logo2_cn")
            .visible = isChines;

        // set banner (game standart) logo
        const bannerScene = ViewManager.getLayer(DefaultLayers.Banners).setScene();
        this.logo = bannerScene.sceneSprites.get("title");
        this.chinesLogo = bannerScene.sceneSprites.get("title_cn")

        this.logo.visible = !isChines;
        this.chinesLogo.visible = isChines;

        // set secondary special (for this game only) logo
        // it used mainly in section bet, autoplay and settings to be clearly visible
        const menuLogoScene = ViewManager.getLayer("MenuLogo")
            .setScene(isChines ? "open_cn" : "open");
        this.secondLogo = menuLogoScene.sceneSprites.get(isChines ? "title_cn" : "title");

        this.timeline = new Timeline({});
    }

    public fixLogoSize(show: boolean) {
        if (show) {
            if (Layout.isLandscape()) {
                this.timeline.to([this.logo, this.secondLogo, this.chinesLogo], 0, 
                    { 
                        width: this.logo.width * 0.8,
                        height: this.logo.height * 0.8,
                        x: this.logo.x + (this.logo.width - this.logo.width * 0.8) /2,
                        ease: Ease.None 
                    }
                );
                this.timeline.play();
            }
        } else {
            if (Layout.isLandscape()) {
                this.timeline.reverse();
            }
        }
    }

}

export default new LogoHelper()